import { NavLink, useLocation } from 'react-router-dom';
import './BottomNavigation.css';

const NAV_ITEMS = [
  { label: 'Inspektionen', to: '/' },
  { label: 'Prüfberichte', to: '/reports' },
  { label: 'Profil', to: '/profile' }
];

export const BottomNavigation = () => {
  const location = useLocation();

  return (
    <nav className="bottom-navigation" aria-label="Hauptnavigation">
      {NAV_ITEMS.map(({ label, to }) => {
        const isActive =
          to === '/'
            ? location.pathname === '/' || location.pathname.startsWith('/inspections')
            : location.pathname.startsWith(to);

        return (
          <NavLink
            key={to}
            to={to}
            className={`bottom-navigation__item ${isActive ? 'bottom-navigation__item--active' : ''}`}
          >
            <span className="bottom-navigation__label">{label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};
